import { ELanguages, EYmEvents, EYmEventsGoals, EYmEventsO1, EYmEventsO2 } from 'shared/typings';
import { getDatetimeGreenwich, getHitId, getUuidV4 } from 'shared/utils';

export const sendYmEvent = (params: {
	event: EYmEvents;
	o1?: EYmEventsO1 | EYmEventsO1[];
	o2?: EYmEventsO2 | EYmEventsO2[];
	o4?: string | string[];
	wi?: string;
	pi?: string;
	si?: string;
	isMarketing?: boolean;
	isBussines?: boolean;
	reachGoal?: EYmEventsGoals;
}) => {
	const { event, o1, o2, o4, wi, pi, si, isMarketing = true, isBussines = true } = params;
	const randomActionInfo = getUuidV4(); // тут должно быть значение uu_id которое генерируется при каждом вызове события

	const eventInfo = {
		[randomActionInfo]:
			`en:${event}` + // event_name
			'|' +
			`o1:${!o1 ? '-' : Array.isArray(o1) ? o1.join(';') : o1}` + // event_option1
			'|' +
			`o2:${!o2 ? '-' : Array.isArray(o2) ? o2.join(';') : o2}` + // event_option2
			'|' +
			'o3:affilead' + // event_option3
			'|' +
			`o4:${!o4 ? '-' : Array.isArray(o4) ? o4.join(';') : o4}` + // event_option4
			'|' +
			'dg:' +
			getDatetimeGreenwich() + // datetime_greenwich
			'|' +
			'hi:' +
			getHitId() + // hit_id
			'|' +
			'lo:' +
			(window.localStorage.i18nextLng || ELanguages.RU) + // locale, скорее всего всегда 'ru'?
			'|' +
			'ut:' +
			document.URL + // url_tags, полный URL со всеми параметрами
			'|' +
			'pi:' +
			`${pi || '-'}` + // program_i, в данном событии передаем '-'
			'|' +
			'ai:' +
			'-' + // advertiser_id, в данном событии передаем '-'
			'|' +
			'of:' +
			'-' + // advcampaign_id, в данном событии передаем '-'
			'|' +
			'ui:' +
			(localStorage.getItem('user_id') || '-') + // publisher_id, передаем ID паблишера (который у affilead формируется) желательно, если есть возможность
			'|' +
			'ki:' +
			(localStorage.getItem('user_id') || '-') + // keycloak_id, передаем mitgo ID пользователя (кейклок) ОБЯЗАТЕЛЬНО
			'|' +
			'wi:' +
			`${wi || '-'}` + // website_id, передаем id площадки
			'|' +
			'pp:' +
			'-' + // page_params, в данном событии передаем '-'
			'|' +
			're:' +
			'-' + // referrer_without_login_page, в данном событии передаем '-'
			'|' +
			'ab:' +
			'-' + // ab_test, в данном событии передаем '-'
			'|' +
			'si:' +
			`${si || '-'}`, // sendbox_id, в данном событии передаем '-'
	};

	if (import.meta.env.VITE_ENVIRONMENT === 'prod') {
		if (isMarketing) {
			// eslint-disable-next-line
			// @ts-ignore
			ym(98715808, 'params', eventInfo); // Send to Marketing YM
		}

		if (isBussines) {
			// eslint-disable-next-line
			// @ts-ignore
			ym(99789588, 'params', eventInfo); // Send to Business YM
		}

		if (params.reachGoal) {
			// eslint-disable-next-line
			// @ts-ignore
			ym(99789588, 'reachGoal', params.reachGoal); // Send to Business YM
		}
	} else {
		console.log(eventInfo);
		// eslint-disable-next-line
		// @ts-ignore
		// ym(101038975, 'params', eventInfo);
	}
};
